// id for stores list in lego response
export var STORE_FEED_ID = 'store_feed';
// used for moment time format of delivery time
export var DELIVERY_TIME_DISPLAY_FORMAT = 'h:mm A';
// default to 12:10 PM so default selected is 12:00 PM - 12:20 PM
export var DEFAULT_DELIVERY_TIME = '12:10 PM';
export var DEFAULT_DELIVERY_TIME_PICKER_START_TIME = '8:00 AM';
export var DEFAULT_DELIVERY_TIME_PICKER_END_TIME = '10:00 PM';
// delivery time range for time picker
export var DELIVERY_TIME_RANGE_INTERVAL = 20;
// type of a group order cart
export var CartTypes;
(function (CartTypes) {
    CartTypes["REGULAR"] = "regular-go";
    CartTypes["SPLIT_BILL"] = "split-bill-go";
})(CartTypes || (CartTypes = {}));
